import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import "../../asset/styles/transportation/transportation.scss"
import utilStyles from "../../asset/styles/util/util.module.scss"
import DayTrip from "./DatTrip"
import Package from "./package"
import { Grid } from "@mui/material"

const Transportation: React.FC = () => {
    const location = useLocation()
    const [activeTab, setActiveTab] = useState<"day-trips" | "packages">(
        () => (location.state as { tab?: string } | null)?.tab === "packages" ? "packages" : "day-trips"
    )

    useEffect(() => {
        if ((location.state as { tab?: string } | null)?.tab === "packages") {
            setActiveTab("packages")
        }
    }, [location.state])

    return (
        <div className={`${utilStyles.pageContainer} ${activeTab === "day-trips" ? utilStyles.listPageFill : ""}`}>
            {/* <div className="transportation-header"> */}
                
                {/* {activeTab === "packages" && (
                    <Button type="contained" label="Add Package" onClick={() => {}} />
                )} */}
            {/* </div> */}

            {/* Tabs */}
            {/* <div className="transportation-tabs">
                <button
                    className={`tab ${activeTab === "day-trips" ? "active" : ""}`}
                    onClick={() => setActiveTab("day-trips")}
                >
                    Day Trips
                </button>
                <button
                    className={`tab ${activeTab === "packages" ? "active" : ""}`}
                    onClick={() => setActiveTab("packages")}
                >
                    Packages
                </button>
            </div> */}

            {/* Tab Content */}
            
                {activeTab === "day-trips" && (
                    <div className={utilStyles.listPageFillPanel}>
                            <DayTrip />
                    </div>
                )}
                {activeTab === "packages" && (
                    <div className="transportation-tab-panel">
                        <Grid container spacing={3} justifyContent="flex-end">
                            <Grid size={{ xs: 12 }}>
                                <Package />
                            </Grid>
                        </Grid>
                    </div>
                )}
        </div>
    )
}

export default Transportation
